import React from "react";

const Sarvashtak = ({ kundli }) => {
  return (
    <div className="kundli_basi row  justify-content-center m-0">
      <h3 className="heding_bx">What is a Sarvashtak ?</h3>
      <p className="my-3">
        Sarvashtakvarga is the summary chart made up for the entire horoscope by
        adding up the score of Bhinnashtakvargha that includes each of the 8
        planets. It identifies the strength of the house, how each house would
        be favourable or unfavourable and it's transiting, evaluation of Dasa
        bhukti, the timing of the events and longevity. The house denotes the
        certain portion of life. Transit of planet with higher points is said to
        be better. The point below 28 shows the bad aspect of life while the
        point above 30 shows the good areas of life. For example, if Pisces gets
        4, 6, 7,5,5,4,5 bindus then Sarvashtakvarga for this zodiac would be
        4+6+7+5+5+4+5 = 36.
      </p>
      <div className="reposive_teble ">
        <table className="w-100">
          <thead>
            <tr>
              <th>Sign</th>
              <th>Sun</th>
              <th>Moon</th>
              <th>Mars</th>
              <th>Mercury</th>
              <th>Jupiter</th>
              <th>Venus</th>
              <th>Saturn</th>
              <th>Ascendant</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Aries</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.aries?.sun}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.aries?.moon}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.aries?.mars}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.aries?.mercury}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.aries?.jupiter}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.aries?.venus}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.aries?.saturn}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.aries?.ascendant}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.aries?.total}</td>
            </tr>
            <tr>
              <td>TAURUS</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.taurus?.sun}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.taurus?.moon}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.taurus?.mars}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.taurus?.mercury}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.taurus?.jupiter}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.taurus?.venus}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.taurus?.saturn}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.taurus?.ascendant}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.taurus?.total}</td>
            </tr>
            <tr>
              <td>GEMINI</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.gemini?.sun}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.gemini?.moon}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.gemini?.mars}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.gemini?.mercury}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.gemini?.jupiter}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.gemini?.venus}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.gemini?.saturn}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.gemini?.ascendant}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.gemini?.total}</td>
            </tr>
            <tr>
              <td>CANCER</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.cancer?.sun}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.cancer?.moon}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.cancer?.mars}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.cancer?.mercury}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.cancer?.jupiter}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.cancer?.venus}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.cancer?.saturn}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.cancer?.ascendant}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.cancer?.total}</td>
            </tr>
            <tr>
              <td>LEO</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.leo?.sun}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.leo?.moon}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.leo?.mars}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.leo?.mercury}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.leo?.jupiter}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.leo?.venus}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.leo?.saturn}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.leo?.ascendant}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.leo?.total}</td>
            </tr>
            <tr>
              <td>VIRGO</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.virgo?.sun}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.virgo?.moon}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.virgo?.mars}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.virgo?.mercury}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.virgo?.jupiter}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.virgo?.venus}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.virgo?.saturn}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.virgo?.ascendant}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.virgo?.total}</td>
            </tr>
            <tr>
              <td>LIBRA</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.libra?.sun}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.libra?.moon}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.libra?.mars}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.libra?.mercury}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.libra?.jupiter}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.libra?.venus}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.libra?.saturn}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.libra?.ascendant}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.libra?.total}</td>
            </tr>
            <tr>
              <td>SCORPIO</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.scorpio?.sun}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.scorpio?.moon}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.scorpio?.mars}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.scorpio?.mercury}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.scorpio?.jupiter}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.scorpio?.venus}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.scorpio?.saturn}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.scorpio?.ascendant}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.scorpio?.total}</td>
            </tr>
            <tr>
              <td>SAGITTARIUS</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.sagittarius?.sun}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.sagittarius?.moon}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.sagittarius?.mars}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.sagittarius?.mercury}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.sagittarius?.jupiter}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.sagittarius?.venus}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.sagittarius?.saturn}</td>
              <td>
                {kundli?.sarvashtak?.ashtak_points?.sagittarius?.ascendant}
              </td>
              <td>{kundli?.sarvashtak?.ashtak_points?.sagittarius?.total}</td>
            </tr>
            <tr>
              <td>CAPRICORN</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.capricorn?.sun}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.capricorn?.moon}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.capricorn?.mars}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.capricorn?.mercury}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.capricorn?.jupiter}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.capricorn?.venus}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.capricorn?.saturn}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.capricorn?.ascendant}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.capricorn?.total}</td>
            </tr>
            <tr>
              <td>AQUARIUS</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.aquarius?.sun}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.aquarius?.moon}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.aquarius?.mars}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.aquarius?.mercury}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.aquarius?.jupiter}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.aquarius?.venus}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.aquarius?.saturn}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.aquarius?.ascendant}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.aquarius?.total}</td>
            </tr>
            <tr>
              <td>PISCES</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.pisces?.sun}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.pisces?.moon}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.pisces?.mars}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.pisces?.mercury}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.pisces?.jupiter}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.pisces?.venus}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.pisces?.saturn}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.pisces?.ascendant}</td>
              <td>{kundli?.sarvashtak?.ashtak_points?.pisces?.total}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Sarvashtak;
